import { useCallback } from 'react';

const useSliderIntersectionObserver = () => {
  const observe = useCallback((callback: (arg: IntersectionObserverEntry) => void) => {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => callback(entry)), {
      root: document.querySelector('.slick-slider.stock-slider'),
      threshold: 1,
      rootMargin: '0px 76px 0px 76px',
    });

    const target = document.querySelector(`.slick-slide:last-child`);

    observer.observe(target);

    return () => observer.unobserve(target);
  }, []);

  return {
    observe,
  };
};

export default useSliderIntersectionObserver;
